import { createTheme } from '@mui/material/styles';

/**
 * Custom Material UI theme with ERP color scheme
 * Primary: Mint Green & Dark Teal
 * Accent: Yellow/Gold
 */
const theme = createTheme({
    palette: {
        primary: {
            main: '#09b8a9',      // brand teal
            light: '#3fd0c2',
            dark: '#06857a',
        },
        secondary: {
            main: '#FFD966',      // card-yellow-stripe
            light: '#FFE699',
            dark: '#E6C34D',
        },
        background: {
            default: '#f6f9f9',   // soft neutral
            paper: '#FFFFFF',     // white
            neutral: '#eef4f3',
        },
        text: {
            primary: '#1f2433',
            secondary: '#6b7280',
        },
        success: {
            main: '#4CAF50',
        },
        error: {
            main: '#F44336',
        },
        warning: {
            main: '#FF9800',
        },
        info: {
            main: '#2D9B8E',      // Using teal for info
        },
    },
    typography: {
        fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
        h1: {
            fontSize: '2.5rem',
            fontWeight: 600,
            color: '#212121',
        },
        h2: {
            fontSize: '2rem',
            fontWeight: 600,
            color: '#212121',
        },
        h3: {
            fontSize: '1.75rem',
            fontWeight: 600,
            color: '#212121',
        },
        h4: {
            fontSize: '1.5rem',
            fontWeight: 600,
            color: '#212121',
        },
        h5: {
            fontSize: '1.25rem',
            fontWeight: 600,
            color: '#212121',
        },
        h6: {
            fontSize: '1rem',
            fontWeight: 600,
            color: '#212121',
        },
        button: {
            textTransform: 'none', // Disable uppercase transformation
            fontWeight: 500,
        },
    },
    shape: {
        borderRadius: 8, // Rounded corners for modern look
    },
    components: {
        MuiCard: {
            styleOverrides: {
                root: {
                    borderRadius: 12,
                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
                    '&:hover': {
                        boxShadow: '0 4px 16px rgba(0, 0, 0, 0.12)',
                        transition: 'box-shadow 0.3s ease-in-out',
                    },
                },
            },
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    '& .MuiOutlinedInput-root': {
                        borderRadius: 8,
                    },
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    borderRadius: 12,
                },
            },
        },
        MuiDrawer: {
            styleOverrides: {
                paper: {
                    backgroundColor: '#FFFFFF',
                    borderRight: '1px solid #E3F0EC',
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 8,
                    padding: '10px 24px',
                    boxShadow: 'none',
                    '&:hover': {
                        boxShadow: 'none',
                    },
                },
                contained: {
                    '&:hover': {
                        transform: 'translateY(-1px)',
                        transition: 'transform 0.2s ease-in-out',
                    },
                },
                containedPrimary: {
                    backgroundColor: '#09b8a9',
                    '&:hover': {
                        backgroundColor: '#06857a',
                    },
                },
            },
        },
    },
});

export default theme;
